import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subscription, of } from 'rxjs';
import { shareReplay, groupBy, catchError } from 'rxjs/operators';
import { IacctRange, Iacct } from '../../shared/models/models';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class IacctService {
  private iacctRanges$: Observable<IacctRange[]> = null;
  private iacctRangeSub: Subscription = null;
  private iaccts$: Observable<Iacct[]> = null;
  iacctRanges: IacctRange[] = null;
  private readonly api = `api/main`;

  constructor(private readonly httpClient: HttpClient,
    private readonly toastr: ToastrService) {}

  getIacctRanges() {
    if (!this.iacctRanges$) {
      this.iacctRanges$ = this.httpClient.get<IacctRange[]>(`${this.api}/iacctranges`).pipe(shareReplay(1));
    }
    return this.iacctRanges$;
  }

  getIaccts(rangeId: number = null) {
    let params = new HttpParams();
    // TypeScript sends "null" as a string if param is null
    if (rangeId != null) {
      params = params.set('rangeId', rangeId.toString());
    }
    this.iaccts$ = this.httpClient
      .get<Iacct[]>(`${this.api}/iaccts`, {
        params: params,
      })
      .pipe(
        catchError(error => {
          this.toastr.error(error.error.message, "Error", {
            closeButton: true,
            timeOut: 5000,
            onActivateTick: true
          });
          return of(null);
        }),
        shareReplay(1)
      );

    return this.iaccts$;
  }
}
